import Alpine from 'alpinejs';
import resourceCenter from './resource-center';

// Gather all data stores that we want to use
const stores = {
    resourceCenter
}

const setupData = () => {
    document.addEventListener('alpine:init', function () {
        Object.keys(stores).forEach(store => {
            Alpine.store(store, (stores[store]));
        });
    });
}
export default setupData;